module.exports = __webpack_public_path__ + "img/private-pizzeriano3-pizzas-3.a78318c2.jpg";